import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Auth } from '../../../autentication/Auth';
import { EventTypes } from '../../../shared/EventTypes';
import { SharedModalInfoComponent } from '../../../shared/modal-info/modal-info.component';
import { ModalTermsComponent } from '../../../shared/modal-terms/modal-terms.component';
import { ThemeService } from '../../../shared/theme-service/theme.service';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { CloseAccountService } from '../close-account.service';

@Component({
	selector: 'app-close-account-information',
	templateUrl: './information.component.html',
	styleUrls: ['./information.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class CloseAccountInformationComponent implements OnInit {

	public userName: string;
	public cpfCnpj: string;
	public agency: number;
	public accountNumber: string;
	public phoneCrCapital = '4004 3500';
	public phoneCrMore = '0800 701 3500';

	constructor(
		private router: Router,
		private closeAccountService: CloseAccountService,
		public dialog: MatDialog,
		private themeService: ThemeService
	) {}

	ngOnInit(): void {
		this.getAccountInformation();
		this.definePhonesByTheme();
	}

	getAccountInformation() {
		this.userName = Auth.getInstance().getUser().loggedUserName;
		this.cpfCnpj = Auth.getInstance().getUser().cpfCnpj;
		this.agency = Auth.getInstance().getUser().agency;
		this.accountNumber = Auth.getInstance().getUser().accountNumber;
	}

	openModal(): void {
		this.closeAccountService.getResolution().subscribe(data => {
			if (data.Sucesso && data.Existe) {
				this.dialog.open(ModalTermsComponent, {
					width: '700px',
					height: '500px',
					data: {
						title: 'Resolução 4753/19',
						text: data.Retorno
					}
				});
			}
		});
	}

	goToNextTab() {
		this.closeAccountService.getStatus().subscribe(
			response => {
				if (response.Sucesso && response.Existe && response.Tipo === 'NoContent') {
					this.router.navigate(['minha-conta/encerramento/requisicao']);
				}
				if (response.Sucesso && response.Existe && response.Tipo === 'OK') {
					this.openModalAlert();
				}
			},
			error => {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			}
		);
	}

	openModalAlert() {
		this.dialog.open(SharedModalInfoComponent, {
			width: '360px',
			data: {
				title: 'Atenção!',
				text: 'Você já possui uma solicitação em andamento. Em caso de dúvidas, entre em contato com nossa Central de Relacionamento.',
				btnName: 'Fechar',
			}
		});
	}

	private definePhonesByTheme() {
		switch (this.themeService.currentURL) {
			case 'www.powerclub.com.br':
				this.phoneCrCapital = '4003 0583';
				this.phoneCrMore = '0800 770 6301';
				break;
		}
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/close-account/information/information.component.ts